import { render, staticRenderFns } from "./shopStatus.vue?vue&type=template&id=70e2b22f&scoped=true"
import script from "./shopStatus.vue?vue&type=script&lang=js"
export * from "./shopStatus.vue?vue&type=script&lang=js"
import style0 from "./shopStatus.vue?vue&type=style&index=0&id=70e2b22f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e2b22f",
  null
  
)

export default component.exports